import clsx from "clsx";
import React from "react";

export const RadioField = ({choices, value, onChange}) => {
  return <div className="radio-field">
    {choices.map(choice =>
      <div key={choice.value}
           className={clsx("radio-field-choice", value === choice.value ? choice.activeClass || "default" : "")}
           onClick={e => {
             e.stopPropagation();

             return onChange(choice.value);
           }}>
        {choice.label}
      </div>)}
  </div>;
};
